const sidebarStatusKey = 'sidebarStatus'

const types = {
    TOGGLE_SIDEBAR: 'TOGGLE_SIDEBAR'
}
function compare (a, b) {
    if (a.order < b.order) { return -1 }
    if (a.order > b.order) { return 1 }
    return 0
}
function checkPermission (v, roles) {
    if (v.meta && v.meta.role && !v.hidden) {
        return roles.some(role2 => v.meta.role.indexOf(role2.toLowerCase()) >= 0)
    } else {
        return true
    }
}
const app = {
    state: {
        sidebar: {
            opened: !+localStorage.getItem(sidebarStatusKey)
        },
        timeZones: [],
        routes: []
    },
    getters: {
        routes: (state) => {
            return state.routes.sort(compare)
        },
        timeZones: (state) => {
            return state.timeZones
        }
    },
    mutations: {
        [types.TOGGLE_SIDEBAR] (state) {
            if (state.sidebar.opened) {
                localStorage.setItem(sidebarStatusKey, 1)
            } else {
                localStorage.setItem(sidebarStatusKey, 0)
            }
            state.sidebar.opened = !state.sidebar.opened
        },
        hideSideBar (state) {
            if (!state.sidebar.opened) {
                localStorage.setItem(sidebarStatusKey, 0)
            }
            state.sidebar.opened = false
        },
        showSideBar (state) {
            if (state.sidebar.opened) {
                localStorage.setItem(sidebarStatusKey, 1)
            }
            state.sidebar.opened = true
        },
        addRoutes (state, payload) {
            let roles = []
            payload = payload.filter((value) => {
                if (!value.noDropdown && !value.hidden) {
                    value.children = value.children.filter((value2) => {
                        return checkPermission(value2, roles)
                    })
                    return checkPermission(value, roles)
                } else {
                    return checkPermission(value, roles)
                }
            })
            state.routes = state.routes.concat(payload)
        }
    },
    actions: {
        toggleSideBar: ({ commit }) => {
            commit(types.TOGGLE_SIDEBAR)
        },
        hideSideBar: ({commit}) => {
            commit('hideSideBar')
        },
        showSideBar: ({commit}) => {
            commit('showSideBar')
        }
    }
}

export default app
